module.exports = __webpack_public_path__ + "img/banner_beauty.69a0875f.png";